<template>
  <div class="noc-container">
    <h1 style="text-align: center">NOC</h1>

    <div class="noc-content">Add your NOC components here</div>
  </div>
  <div class="container-fluid">
    modalTheme {{ modalTheme }}
    <div :class="userStore.borderClass" style="height: 340px; overflow-y: auto">userStore.borderClass {{ userStore.borderClass }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);
onMounted(() => {
  // console.log("onMounted() :      NOC >>>>");
});
</script>

<style scoped>
.noc-container {
  padding: 20px;
}

.noc-content {
  margin-top: 20px;
}
</style>
